
import PromiseWorker from 'promise-worker'
import Worker from 'worker-loader!./sch_worker.js'

const _workerInstance = new Worker()
const schedulerWorker = new PromiseWorker(_workerInstance)

const available = data => schedulerWorker.postMessage({
  type: 'available',
  data
})

function terminate() {
  _workerInstance.terminate && _workerInstance.terminate()
}

export default {
  available,
  terminate
}
